const FormResources = {

    form_data:{
        last_completed: '',
        actual_minutes: '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'last_completed',
            ref:        'last_completed_input',
            ref_alt:    'last_completed_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Actual minutes:',
            model_name: 'actual_minutes',
            ref:        'actual_minutes_input',
            ref_alt:    'actual_minutes_input_alt',
            required:   false,
        },
    ],

}

export default FormResources;